class PriceRange {
  constructor(container) {
    this.container = container;
    this.minRange = container.querySelector('.price-range__min');
    this.maxRange = container.querySelector('.price-range__max');
    this.progress = container.querySelector('.price-range__progress');
    this.minInput = container.querySelector('.price-range__value:first-child .price-range__input');
    this.maxInput = container.querySelector('.price-range__value:last-child .price-range__input');

    this.minPrice = parseInt(this.container.dataset.minPrice);
    this.maxPrice = parseInt(this.container.dataset.maxPrice);
    
    // Récupérer les valeurs des filtres de l'URL
    const urlParams = new URLSearchParams(window.location.search);
    const minFilterPrice = urlParams.get('filter.v.price.gte');
    const maxFilterPrice = urlParams.get('filter.v.price.lte');

    // Initialiser avec les valeurs de l'URL si présentes, sinon utiliser les valeurs par défaut
    if (minFilterPrice) {
      this.minRange.value = minFilterPrice;
      this.minInput.value = minFilterPrice;
    }
    if (maxFilterPrice) {
      this.maxRange.value = maxFilterPrice;
      this.maxInput.value = maxFilterPrice;
    }
    
    this.bindEvents();
    this.updateProgress();
  }

  bindEvents() {
    // Gérer les changements sur les sliders
    ['input', 'change', 'mouseup', 'touchend'].forEach(eventType => {
      this.minRange.addEventListener(eventType, () => {
        let minVal = parseInt(this.minRange.value);
        let maxVal = parseInt(this.maxRange.value);
        
        if (minVal > maxVal) {
          this.minRange.value = maxVal;
          minVal = maxVal;
        }
        
        this.minInput.value = minVal;
        this.updateProgress();
      });

      this.maxRange.addEventListener(eventType, () => {
        let minVal = parseInt(this.minRange.value);
        let maxVal = parseInt(this.maxRange.value);
        
        if (maxVal < minVal) {
          this.maxRange.value = minVal;
          maxVal = minVal;
        }
        
        this.maxInput.value = maxVal;
        this.updateProgress();
      });
    });

    // Gérer les changements sur les inputs
    this.minInput.addEventListener('change', () => {
      let value = parseInt(this.minInput.value);
      if (isNaN(value)) {
        value = this.minPrice;
      }
      value = Math.max(this.minPrice, Math.min(parseInt(this.maxRange.value), value));
      this.minInput.value = value;
      this.minRange.value = value;
      this.updateProgress();
    });

    this.maxInput.addEventListener('change', () => {
      let value = parseInt(this.maxInput.value);
      if (isNaN(value)) {
        value = this.maxPrice;
      }
      value = Math.max(parseInt(this.minRange.value), Math.min(this.maxPrice, value));
      this.maxInput.value = value;
      this.maxRange.value = value;
      this.updateProgress();
    });
  }

  updateProgress() {
    const minVal = parseInt(this.minRange.value);
    const maxVal = parseInt(this.maxRange.value);
    const percent = (val) => ((val - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;
    
    this.progress.style.left = percent(minVal) + '%';
    this.progress.style.right = (100 - percent(maxVal)) + '%';
  }
}

// Initialiser tous les sliders de prix
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.price-range').forEach(container => {
    new PriceRange(container);
  });
});